module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCondIt.869d96dc.otf";